import { createAsyncThunk } from '@reduxjs/toolkit';
import { EnglishLevelParams } from './EnglishLevel.type';
import englishLevelService from './EnglishLevel.service';

export const getEnglishLevelListThunk = createAsyncThunk(
  'englishLevel/getEnglishLevelListThunk',
  async (params: EnglishLevelParams, thunkAPI) => {
    const response = await englishLevelService.getList(params);
    return response.data;
  },
);
